"use strict";

var _regeneratorRuntime = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/alecresende/code/visual-sampler/sequencer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useOpenseaNFT = void 0;

var tslib_1 = require("tslib");

var react_1 = require("react");

var swr_1 = tslib_1.__importDefault(require("swr"));

var NFTFetchContext_1 = require("../context/NFTFetchContext");

var OpenseaUtils_1 = require("../fetcher/OpenseaUtils");
/**
 * Fetches on-chain NFT data and pricing for the given zNFT id
 *
 * @param contractAddress address of the contract
 * @param tokenId id of NFT to fetch blockchain information for
 * @param options SWR flags and an option to load currency info
 * @returns useNFTType hook results include loading, error, and chainNFT data.
 */


function useOpenseaNFT(contractAddress, tokenId) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _a;

  var fetcher = react_1.useContext(NFTFetchContext_1.NFTFetchContext);

  var _ref = options || {},
      _ref$loadCurrencyInfo = _ref.loadCurrencyInfo,
      loadCurrencyInfo = _ref$loadCurrencyInfo === void 0 ? false : _ref$loadCurrencyInfo,
      refreshInterval = _ref.refreshInterval,
      initialData = _ref.initialData;

  var nftData = swr_1.default(contractAddress && tokenId ? ['loadGenericNFT', contractAddress, tokenId] : null, function (_, contractAddress, tokenId) {
    return fetcher.loadNFTDataUntransformed(contractAddress, tokenId);
  }, {
    dedupingInterval: 0
  });
  var auctionData = swr_1.default(contractAddress && tokenId ? ['loadAuctionForNFT', contractAddress, tokenId] : null, /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_, contractAddress, tokenId) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", fetcher.loadAuctionInfo(contractAddress, tokenId));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }());
  var nftResponseData = nftData.data;
  var currencyData = swr_1.default(nftResponseData && loadCurrencyInfo ? ['loadCurrencies', (_a = auctionData.data) === null || _a === void 0 ? void 0 : _a.auctionCurrency] : null, function (_) {
    for (var _len = arguments.length, currencies = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      currencies[_key - 1] = arguments[_key];
    }

    return fetcher.loadCurrencies(currencies);
  }, {
    refreshInterval: refreshInterval,
    dedupingInterval: 0
  });
  var data = undefined;

  if (nftData.data !== undefined) {
    data = OpenseaUtils_1.transformOpenseaResponse(nftData.data, auctionData.data, currencyData.data);
  } else {
    data = initialData;
  }

  return {
    currencyLoaded: !!currencyData.data,
    error: nftData.error,
    data: data
  };
}

exports.useOpenseaNFT = useOpenseaNFT;